/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { Pipe, PipeTransform, inject } from '@angular/core'
import { PhoneNumberService } from '../services'

@Pipe({
  name: 'formattedNumber',
  pure: false,
  standalone: false,
})
export class MyProfileFormattedPhoneNumberPipe implements PipeTransform {
  private phoneNumberService = inject(PhoneNumberService)

  transform(value: string | null | undefined, args?: any): any {
    return this.phoneNumberService.getFormattedPhoneNumber(value ?? '', args)
  }
}
